export default {
  home: "/",
  moviesPage: "/movies",
  movieDetailsPage: "/movies/:movieId",
  cast: "/movies/:movieId/cast",
  reviews: "/movies/:movieId/reviews",
  trailers: "/movies/:movieId/trailers",
};
